export const FETCH_METRICS_REQUEST = 'Metrics/FETCH_METRICS_REQUEST' as const;
export const FETCH_METRICS_RESPONSE = 'Metrics/FETCH_METRICS_RESPONSE' as const;
export const FETCH_METRICS_ERROR = 'Metrics/FETCH_METRICS_ERROR' as const;
